export enum TileType {
  INFO = 'info',
  CAST = 'cast',
  TRIGGER = 'trigger',
  CAROUSEL = 'carousel',
  UPGRADE = 'upgrade',
  SHOP = 'shop',
  TEXT = 'text',
  AUDIO = 'audio',
}
